import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import { setAccessToken, setMustChangePassword } from '../../../views/auth/reducer';
import { firstLoginPasswordChange } from '../../../api/authApi';
import ConfirmModal from '../confirm/ConfirmModal';

import './ModalTrocaSenhaPrimeiroAcesso.css';

interface ModalTrocaSenhaPrimeiroAcessoProps {
  onDefer?: () => void;
}

const ModalTrocaSenhaPrimeiroAcesso: React.FC<ModalTrocaSenhaPrimeiroAcessoProps> = ({ onDefer }) => {
  const dispatch = useDispatch();

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmDefer, setShowConfirmDefer] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('As novas senhas não coincidem.');
      return;
    }

    setIsLoading(true);

    try {
      const { token, user } = await firstLoginPasswordChange(currentPassword, newPassword, confirmPassword);

      localStorage.setItem('authToken', token);
      dispatch(setAccessToken(token));
      dispatch(setMustChangePassword(user.mustChangePassword));

      toast.success('Senha alterada com sucesso!');
      setTimeout(() => {
        window.location.href = '/home';
      }, 1000);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Erro ao trocar a senha.';
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmDefer = () => {
    setShowConfirmDefer(false);
    sessionStorage.setItem('passwordChangeDeferred', 'true');
    toast.info('Você pode trocar a senha depois em Minhas informações.');
    if (onDefer) {
      onDefer();
    }
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget && !isLoading) {
      setShowConfirmDefer(true);
    }
  };

  return (
    <>
      <div className="modal-troca-senha-overlay" onClick={handleOverlayClick}>
        <div className="modal-troca-senha-content">
          <div className="troca-senha-modal-card">
            <div className="troca-senha-modal-header">
              <h2 className="troca-senha-modal-title">Troca de senha pendente</h2>
              <p className="troca-senha-modal-subtitle">
                Sua senha foi definida por outra pessoa ou este é seu primeiro acesso. Por segurança, recomendamos definir uma senha só sua. Você pode trocar agora ou depois.
              </p>
            </div>

            <form className="troca-senha-modal-body" onSubmit={handleSubmit}>
              <div className="troca-senha-field">
                <label htmlFor="currentPassword">Senha atual</label>
                <input
                  id="currentPassword"
                  name="currentPassword"
                  type="password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="Senha temporária"
                  autoComplete="current-password"
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="troca-senha-field">
                <label htmlFor="newPassword">Nova senha</label>
                <input
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Nova senha"
                  autoComplete="new-password"
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="troca-senha-field">
                <label htmlFor="confirmPassword">Confirmar nova senha</label>
                <input
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirme a nova senha"
                  autoComplete="new-password"
                  required
                  disabled={isLoading}
                />
              </div>

              <div className="troca-senha-modal-footer">
                <button type="submit" className="troca-senha-btn-primary" disabled={isLoading}>
                  {isLoading ? 'Salvando...' : 'Salvar nova senha'}
                </button>
                <button
                  type="button"
                  className="troca-senha-btn-secondary"
                  onClick={() => setShowConfirmDefer(true)}
                  disabled={isLoading}
                >
                  Trocar depois
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <ConfirmModal
        isOpen={showConfirmDefer}
        title="Trocar a senha depois?"
        message="Você poderá alterar sua senha a qualquer momento acessando a tela de Minhas informações."
        confirmLabel="Sim, trocar depois"
        onConfirm={handleConfirmDefer}
        onCancel={() => setShowConfirmDefer(false)}
      />
    </>
  );
};

export default ModalTrocaSenhaPrimeiroAcesso;
